<template>
  <div class="nav">
    <div class="navTitle">个人服务</div>
    <ul class="navMenu">
      <li class="navMenuItem">
        <div class="nTitle nActive" @click="handleNavClick">
          <i class="nIcon grxx"></i>数据档案<i class="arrowUp"></i>
        </div>
        <ul class="childMenu">
          <li class="active">数据档案</li>
          <li class="">勘误记录</li>
        </ul>
      </li>
      <li class="navMenuItem">
        <div class="nTitle" onclick="handleNavClick(this)">
          <i class="nIcon grxxbg"></i>个人信息报告
        </div>
        <!-- <i class="nIcon grfw"></i> -->
      </li>
      <li class="navMenuItem">
        <div class="nTitle" onclick="handleNavClick(this)">
          <i class="nIcon bgcysq"></i>查验申请
        </div>
        <!-- <i class="nIcon grfw"></i> -->
      </li>
      <li class="navMenuItem">
        <div class="nTitle" onclick="handleNavClick(this)">
          <i class="nIcon cytr"></i>查验他人<i class="arrowDown"></i>
        </div>
        <!-- <i class="nIcon grfw"></i> -->
      </li>
    </ul>
  </div>
</template>

<script>
export default {
    methods:{
        handleNavClick(){
            console.log(this);
        }
    }
};
</script>

<style scoped lang="scss">
.nav {
  margin-top: 39px;
  padding: 26px 17px 0px 18px;
  width: 257px;
  background: #fff;
  box-sizing: border-box;
  .navTitle {
    background: #3a61b1;
    color: #f9f9f9;
    font-size: 26px;
    //   margin-bottom: 22px;
    //   padding: 43px 58px 39px 57px;
    padding: 36px 56px 35px 56px;
  }
  .navMenu {
    // margin-top: 39px;
    // margin-bottom: 39px;
    color: #6e6e6e;
    padding-top: 39px;
    padding-bottom: 39px;
    list-style: none;
    font-size: 18px;
    display: flex;
    flex-direction: column;
    .navMenuItem {
      padding: 24px 0 0px 0px;
      cursor: pointer;
      .nActive {
        .grxx {
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu1_active.png") no-repeat !important;
        }
        .grxxbg {
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu2_active.png") no-repeat !important;
        }
        .bgcysq {
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu3_active.png") no-repeat !important;
        }
        .cytr {
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu4_active.png") no-repeat !important;
        }
      }
      .nTitle {
        display: flex;
        align-items: center;
        padding-left: 31px;
        padding-right: 15px;
        position: relative;
        .nIcon {
          width: 26px;
          height: 26px;
          display: inline-block;
          background: #dbdbdb;
          margin-right: 22px;
          background-size: cover !important;
        }
        .grxx {
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu1.png") no-repeat;
        }

        .grxxbg {
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu2.png") no-repeat;
        }
        .bgcysq {
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu3.png") no-repeat;
        }
        .cytr {
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu4.png") no-repeat;
        }

        .arrowDown {
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_arrow_down.png") no-repeat;
          background-size: cover;
          width: 12px;
          height: 7px;
          display: inline-block;
          position: absolute;
          right: 15px;
        }
        .arrowUp {
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_arrow_down.png") no-repeat;
          background-size: cover;
          transform: rotate(180deg);
          width: 12px;
          height: 7px;
          display: inline-block;
          position: absolute;
          right: 15px;

          //   width: 0;
          //   height: 0;
          //   position: relative;
          //   border: 60px solid;
          //   border-color: blue transparent transparent transparent;
        }
        // .arrowUp::after {
        //   content: "";
        //   position: absolute;
        //   top: -68px;
        //   left: -60px;
        //   border: 60px solid;
        //   border-color: white transparent transparent transparent;
        // }
        // .arrowDwon {
        //   width: 0;
        //   height: 0;
        //   position: relative;
        //   border: 60px solid;
        //   border-color: blue transparent transparent transparent;
        // }
        // .arrowDwon::after {
        //   content: "";
        //   position: absolute;
        //   top: -68px;
        //   left: -60px;
        //   border: 60px solid;
        //   border-color: white transparent transparent transparent;
        // }
      }

      .childMenu {
        display: inline-block;
        //   display: none;
        list-style: none;
        font-size: 16px;
        width: 100%;
        //   height: 64px;
        padding: 24px 0 0 0;
        li {
          // height: 64px;
          padding: 21.5px 0;
          // padding: 24px 0;
          text-align: center;
          cursor: pointer;
        }
      }
      .active {
        background: #e7ecf6;
        color: #3a61b1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SiderBar.vue